import { CurrencyStatistic } from 'components/molecules/Statistic'
import { HelpInfo, HelpInfoWrapper } from 'components/molecules/HelpInfo'
import styled from 'styled-components'
import { AssetItem } from './types'
import { CurrencyValue } from '@usedapp/core'
import { Label, LabelWrapper } from 'components/atoms/Label'
import { Row } from 'components/atoms/Row'

interface AssetStatisticProps extends Pick<AssetItem, 'label' | 'tooltip' | 'color'> {
  value: CurrencyValue
  newValue?: CurrencyValue
  view?: 'column' | 'row'
  showNoChange?: boolean
}

export const AssetStatistic = ({
  label,
  value,
  tooltip,
  color,
  newValue,
  view = 'column',
  showNoChange,
}: AssetStatisticProps) => {
  return (
    <>
      {view === 'column' ? (
        <AssetStatisticContainer view={view}>
          <Row>
            <Label>{label}</Label>
            {!!tooltip && <HelpInfo info={tooltip} />}
          </Row>
          <Row>
            <AssetTile color={color} />
            <CurrencyStatistic
              value={value}
              newValue={newValue}
              placeholder="N/A"
              extraBold
              fixedPrecisionDigits={2}
              showNoChange={showNoChange}
            />
          </Row>
        </AssetStatisticContainer>
      ) : (
        <AssetStatisticContainer view={view}>
          <AssetTile color={color} />
          <Label>{label}</Label>
          {!!tooltip && <HelpInfo info={tooltip} />}
          <CurrencyStatistic
            value={value}
            newValue={newValue}
            placeholder="N/A"
            extraBold
            fixedPrecisionDigits={2}
            showNoChange={showNoChange}
          />
        </AssetStatisticContainer>
      )}
    </>
  )
}

export const AssetTile = styled.div<{ color?: string }>`
  width: 10px;
  height: 10px;
  border-radius: 2px;
  margin-left: 5px;
  background: ${({ color }) => color};
`

export const AssetStatisticContainer = styled.div<{ view?: 'column' | 'row' }>`
  display: flex;
  align-items: ${({ view }) => (view === 'column' ? 'unset' : 'center')};
  flex-direction: ${({ view }) => (view === 'column' ? 'column' : 'row')};
  gap: 5px;

  ${LabelWrapper} {
    font-size: 16px;
    font-weight: normal;
  }

  ${AssetTile} {
    margin-right: ${({ view }) => (view === 'column' ? '5px' : '1px')};
  }

  ${HelpInfoWrapper} {
    margin-left: ${({ view }) => (view === 'column' ? '5px' : 'unset')};
    margin-top: 1px;
  }
`
